import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

// eslint-disable-next-line @change/sibling-module-imports
import { BadgeScore } from 'src/app/shared/components/badgeScore/index_new';

type Props = { score: number };
export function PetitionStrengthCard({ score }: Props): JSX.Element {
	return (
		<div className="bg-background-base elevation-low stroke-weaker flex h-full flex-col gap-2 rounded-xl border p-4">
			<Text as="p" size="xx-small" variant="heading" className="lowercase first-letter:uppercase">
				<Translate value="corgi.petition.details.strength_score.title" />
			</Text>
			<BadgeScore
				score={score}
				sx={{
					// eslint-disable-next-line @typescript-eslint/naming-convention
					'& #score-text': { fontSize: '14px' },
				}}
			/>
		</div>
	);
}
